"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositOnboardingSource = void 0;
/**
 * Which origination path a new deposit member came in through. Decides the APY of the product they onboard onto, and
 * the copy the onboarding funnel renders.
 * @TranslateToPython
 */
var DepositOnboardingSource;
(function (DepositOnboardingSource) {
    DepositOnboardingSource["DEFAULT"] = "DEFAULT";
    // TODO: the bundle values keep the original bundle names because they are serialized into underwriting specs as DEPOSIT_ONBOARDING_SOURCE. Renaming them needs a legacy read for existing specs.
    DepositOnboardingSource["CASHBACK_BOOST_DEPOSIT_BUNDLE"] = "REWARDS_CHECKING_BUNDLE";
    DepositOnboardingSource["FOREST_RIVER"] = "FOREST_RIVER";
    DepositOnboardingSource["APR_DISCOUNT_DEPOSIT_BUNDLE_HIGH_YIELD_CHECKING"] = "HOME_DEPOSIT_BUNDLE_HIGH_YIELD_CHECKING";
})(DepositOnboardingSource || (exports.DepositOnboardingSource = DepositOnboardingSource = {}));
